import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { LeafletMapTitle, MapTitle } from "../../../../Constants/Constants";
import AustraliaMap from "./AustraliaMap";
import IndiaMap from "./IndiaMap";
import UsaMap from "./UsaMap";
import WorldMap from "./WorldMap";
import { Fragment } from "react/jsx-runtime";

const LeafletMapsContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={LeafletMapTitle} parent={MapTitle} />
      <Container fluid>
        <Row>
          <WorldMap />
          <UsaMap />
          <IndiaMap />
          <AustraliaMap />
        </Row>
      </Container>
    </Fragment>
  );
};
export default LeafletMapsContainer;
